import { render, staticRenderFns } from "./assist_server.vue?vue&type=template&id=feb7a77a&scoped=true"
import script from "./assist_server.vue?vue&type=script&lang=js"
export * from "./assist_server.vue?vue&type=script&lang=js"
import style0 from "./assist_server.vue?vue&type=style&index=0&id=feb7a77a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb7a77a",
  null
  
)

export default component.exports